module.exports = __webpack_public_path__ + "img/rayo-vallecano.c1f7b6b6.png";